var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinShakeExtensionPuzzle = function SvgPinShakeExtensionPuzzle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19468_56844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33203 21H5.11203",
    stroke: "#64B1FD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7246 20.9989L8.33258 20.9989L5.11258 20.9999C3.9468 20.9999 3.00158 20.0549 3.00158 18.8891V15.6688C3.46807 15.7629 3.9502 15.7315 4.40058 15.5778C5.2376 15.2916 5.87264 14.6008 6.08758 13.7428C6.44923 12.3279 5.59545 10.8878 4.18061 10.5261C3.96754 10.4717 3.7485 10.444 3.52858 10.4438C3.35127 10.4441 3.17444 10.4618 3.0006 10.4968L3.00158 7.27793C3.00137 6.11236 3.94601 5.16727 5.11158 5.16693H8.33158C8.29663 4.9931 8.27888 4.81624 8.27858 4.63893C8.28013 3.1786 9.46522 1.99602 10.9256 1.99756C11.1455 1.99779 11.3645 2.02546 11.5776 2.07993C12.4357 2.29486 13.1264 2.9299 13.4126 3.76693C13.5663 4.21731 13.5977 4.70043 13.5036 5.16693L16.7236 5.16593C17.8894 5.16593 18.8346 6.11098 18.8346 7.27677V10.4971C19.0084 10.4621 19.1853 10.4444 19.3626 10.4441C20.8229 10.4456 22.0054 11.6307 22.0039 13.091C22.0037 13.3109 21.976 13.5298 21.9216 13.7428C21.7061 14.6006 21.0712 15.2911 20.2346 15.5778C19.7842 15.7316 19.3011 15.763 18.8346 15.6688L18.8346 18.8888C18.8347 20.0546 17.8898 20.9998 16.724 20.9999",
    stroke: "#64B1FD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19468_56844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(0 1 -1 0 24 0)"
  })))));
};
export { SvgPinShakeExtensionPuzzle as ReactComponent };
export default __webpack_public_path__ + "pin-shake-extension-puzzle.svg";